import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateOrderDocuments, type OrderDocumentType } from '@api/orders';
import { asyncTasksQueryKeys } from '@api/asyncTasks';

export interface GenerateOrderDocumentsVariables {
  orderId: number;
  documentTypes: OrderDocumentType[];
}

export function useGenerateOrderDocuments() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ orderId, documentTypes }: GenerateOrderDocumentsVariables) =>
      generateOrderDocuments(orderId, documentTypes),
    onSuccess: () => {
      // Surface the new task in the Activity Centre.
      queryClient.invalidateQueries({ queryKey: asyncTasksQueryKeys.lists() });
    },
  });
}
